import React, { useId } from 'react';

interface SunIconProps {
  className?: string;
  size?: number;
}

/**
 * Sun icon component
 * Displays a sun with gradient for light mode
 */
export const SunIcon: React.FC<SunIconProps> = ({ 
  className = "", 
  size 
}) => {
  const sizeProps = size ? { width: size, height: size } : {};
  const uid = useId();
  const id = (name: string) => `${uid}-${name}`;
  
  return (
    <svg
      {...sizeProps}
      className={className}
      viewBox="0 0 512 512"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <linearGradient id={id("sun")}>
          <stop offset="0" style={{ stopColor: '#ffcc00', stopOpacity: 1 }} />
          <stop offset="0.44253263" style={{ stopColor: '#ffa233', stopOpacity: 0.99607843 }} />
          <stop offset="1" style={{ stopColor: '#e87e53', stopOpacity: 0.99656355 }} />
        </linearGradient>
        <linearGradient
          xlinkHref={`#${id("sun")}`}
          id={id("sun-applied")}
          x1="254.27731"
          y1="60.47506"
          x2="258.58401"
          y2="448.94092"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0.73499901,0,0,0.73499901,67.758137,67.758627)"
        />
      </defs>
      <g>
        <path
          d="M 428.88572,449.74876 323.38256,383.72511 320.60929,508.15322 257.87356,400.6624 197.59335,509.54918 191.99711,385.21606 88.019416,453.61691 140.84465,340.9247 16.989538,353.16981 116.13465,277.93495 0.77579909,231.21908 123.52782,210.67695 43.092586,115.70217 161.33049,154.55876 134.2456,33.082622 220.88253,122.43631 253.35283,2.2875651 288.5413,121.6685 373.1282,30.371782 348.80694,152.43127 l 117.32569,-41.52973 -78.25923,96.77563 123.18656,17.75121 -114.26902,49.3217 100.8269,72.96556 -124.10112,-9.43127 z"
          fill="#ff8e06"
        />
        <circle
          cx="255.91789"
          cy="255.91841"
          r="142.44446"
          fill={`url(#${id("sun-applied")})`}
        />
      </g>
    </svg>
  );
};
